module.exports = __webpack_public_path__ + "img/artboard9.9d99f0f2.png";